import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Reassign Draft Sales Order (OMS v3). Re-homes a draft (and its line items) to
 * another organization and routes it there via DRAFT_SALES_ORDER_ROUTED. Used on
 * the routing org's manual-assignment path (after a Gently-team review action
 * picks the target org for an unclassified draft) and to correct a wrong
 * organization classification.
 *
 * Backend-only (DB + event publish); handler in
 * backend/src/workflows/steps/order-management/.
 */
export const reassignDraftSalesOrderStep = defineStepConfig({
  type: "reassign_draft_sales_order",
  name: "Reassign Draft Sales Order",
  description:
    "Re-homes a draft sales order to another organization and routes it there",
  category: "Data Access",
  libraryModule: "OrderManagement",
  inputSchema: z.object({
    draftSalesOrderId: z
      .string()
      .uuid()
      .describe("The draft sales order to reassign"),
    toOrganizationId: z
      .string()
      .uuid()
      .describe("The organization to route the draft to"),
  }),
  outputSchema: z.object({
    draftSalesOrderId: z.string().uuid(),
    fromOrganizationId: z.string().uuid(),
    toOrganizationId: z.string().uuid(),
  }),
  configSchema: z.object({
    reason: z
      .string()
      .optional()
      .describe("Optional note recorded on the reassignment audit entry"),
    emitRoutedEvent: z
      .boolean()
      .optional()
      .describe(
        "Publish DRAFT_SALES_ORDER_ROUTED to the target org after reassigning (default true). Turn off when a downstream Emit System Event step handles routing, to avoid a double publish.",
      ),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "1 minute",
    retry: {
      maximumAttempts: 2,
    },
  },
});
